// extracted by mini-css-extract-plugin
export default {"date_container":"DateTabs_date_container__C5AZH","route":"DateTabs_route__XtW1l","active":"DateTabs_active__7LCgS"};